import { ConfigProvider, Tabs } from "antd";
import m3_logo from "../assets/images/M3_Logo.svg";
import chartsBanner from "../assets/images/chartsBanner.png";
import introImage from "../assets/images/introImage.png";
import tierBanner from "../assets/images/tierBanner.png";

import { useState } from "react";
import TabsBox from "../Components/TabsBox/TabsBox";
import {
  Bag_icon,
  Couse_profile_Icon,
  IntroIcon,
  StatsIcon,
} from "../utils/icons";

const items = [
  {
    key: "1",
    label: "Introduction",
    children: (
      <TabsBox
        // setActiveTab={setActiveTab("1")}
        title={"Introduction"}
        banner={introImage}
      />
    ),
    icon: <IntroIcon />,
  },
  {
    key: "2",
    label: "Tiers Information",
    children: (
      <TabsBox
        // setActiveTab={setActiveTab("2")}
        title={"Tiers Information"}
        banner={tierBanner}
      />
    ),
    icon: <Couse_profile_Icon />,
  },
  {
    key: "3",
    label: "Job Notification",
    children: (
      <TabsBox
        // setActiveTab={setActiveTab("3")}
        title={"Job Notification"}
        banner={chartsBanner}
      />
    ),
    icon: <Bag_icon />,
  },
  {
    key: "4",
    label: "Current Stats",
    children: (
      <TabsBox
        // setActiveTab={setActiveTab("4")}
        title={"Current Stats"}
        banner={tierBanner}
      />
    ),
    icon: <StatsIcon />,
  },
];

const BeforeApprovalDashboard = () => {
  const [activeTab, setActiveTab] = useState("2");

  const changeTab = (key) => {
    setActiveTab(key);
  };
  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            colorText: "#C4C4C4",
            itemHoverColor: "#C4C4C4",
            lineWidth: "0px",
            colorPrimary: "#ffffff",
          },
        },
      }}
    >
      <div className="tabsStyle bg-darkJungleGreen h-screen flex items-center">
        <div className="m3_logo_register absolute top-10 left-16">
          <img src={m3_logo} />
        </div>
        <Tabs
          activeKey={activeTab}
          onChange={changeTab}
          indicatorSize={0}
          defaultActiveKey="1"
          items={items}
          tabPosition="left"
        ></Tabs>
      </div>
    </ConfigProvider>
  );
};

export default BeforeApprovalDashboard;
